import React, {Component} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { difference, union, indexOf, uniqBy } from 'lodash';
import LoadingOverlay from 'react-loading-overlay';
import { Button, Modal as ReactstrapModal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import { getLinesBulk, editLinesBulk } from '../../state/services/bookingLinesService';
import { getPackageTypes } from '../../state/services/extraService';
import { dmeLabelBulk } from '../../state/services/bookingService';

import ConfirmModal from '../../components/CommonModals/ConfirmModal';
import { getCubicMeter, getWeight } from '../../commons/helpers';
import { CARTONS, PALLETS, PACKED_STATUS_MAP } from '../../commons/constants';
import { STATIC_HOST, HTTP_PROTOCOL } from '../../config';

class ItemsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            orderStats: [],
            orderNumbers: [],
            bookingLines: [],
            selectedLines: [],
            selectedLineIds: [],
            selectedOrderNos: [],
            selectedLineIndex: null,
            filterKeyword: null,
            filterOnly: 'all',
            allCheckStatus: 'None',     // TYPE-1: All table
            allCheckStatus2: 'None',    // TYPE-2: Stats table
            formInputs: {
                b_client_order_num: '',
                packed_status: 'scanned',
                e_type_of_packaging: 'carton',
                e_qty: 0,
                e_dimLength: 0,
                e_dimWidth: 0,
                e_dimHeight: 0,
                e_dimUOM: 'cm',
                e_weightUOM: 'kg',
                e_weightPerEach: 0,
                e_bin_number: 'REPACK-BIN',
                sscc: null,
                warranty_value: 0,
                warranty_percent: 2,
                warranty_fee: 0,
                note: '',
                selectedOrderNo: '',
                is_deleted: false,
            },
            editMode: 'create',         // Create, Update
            isShowCloseConfirmModal: false,
            hasChange: false,
        };

        this.toggleCloseConfirmModal = this.toggleCloseConfirmModal.bind(this);
    }

    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        toggle: PropTypes.func.isRequired,
        bookingIds: PropTypes.array.isRequired,
        getLinesBulk: PropTypes.func.isRequired,
        editLinesBulk: PropTypes.func.isRequired,
        getPackageTypes: PropTypes.func.isRequired,
        dmeLabelBulk: PropTypes.func.isRequired,
        notify: PropTypes.func.isRequired,

        // Data
        clientname: PropTypes.string,
        bookingLines: PropTypes.array,
        packageTypes: PropTypes.array.isRequired,
        labelUrl: PropTypes.string,
    };

    static defaultProps = {
        isOpen: false,
        bookingLines: [],
        packageTypes: [],
    };

    componentDidMount() {
        this.props.getPackageTypes();
        this.setState({isShowLoadingSpinner: true});
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { isOpen, bookingIds, bookingLines, labelUrl } = newProps;

        if (isOpen && this.props.isOpen !== isOpen) {
            this.props.getLinesBulk(bookingIds);
        }

        if (bookingLines && this.props.bookingLines !== bookingLines) {
            const orderNumbers = uniqBy(bookingLines, 'b_client_order_num')
                .map(line => line.b_client_order_num);
            const orderStats = [];
            orderNumbers.map(orderNumber => {
                const scannedCnt = bookingLines.filter(line => line.packed_status === 'scanned').length;
                const packed_status = scannedCnt > 0 ? 'scanned' : 'original';

                let orderStat = {'orderNumber': orderNumber, 'packet': 0, 'carton': 0, 'pallet': 0};
                bookingLines.map(line => {
                    if (orderNumber === line.b_client_order_num) {
                        if (line.packed_status === packed_status) {
                            if (CARTONS.includes(line.e_type_of_packaging.toUpperCase())) {
                                orderStat['carton'] += 1;
                            } else if (PALLETS.includes(line.e_type_of_packaging.toUpperCase())) {
                                orderStat['pallet'] += 1;
                            } else {
                                orderStat['packet'] += 1;
                            }
                        }

                        orderStat['b_bookingID_Visual'] = line.b_bookingID_Visual;
                        orderStat['deToCompanyName'] = line.deToCompanyName;
                    }
                });
                orderStats.push(orderStat);
            });
            this.setState({bookingLines, orderNumbers, orderStats, isShowLoadingSpinner: false});
        }

        if (labelUrl && labelUrl !== this.props.labelUrl) {
            this.setState({isShowLoadingSpinner: false, selectedLines: [], selectedLineIds: [], allCheckStatus: 'NONE'});
            const win = window.open(HTTP_PROTOCOL + '://' + STATIC_HOST + '/pdfs/' + labelUrl, '_blank');
            win.focus();
        }
    }

    toggleCloseConfirmModal() {
        this.setState(prevState => ({isShowCloseConfirmModal: !prevState.isShowCloseConfirmModal}));
    }

    onCheck(e, id, type) {
        if (type === 'TYPE-1') {
            let bookingLines = this.state.bookingLines;
            let selectedLineIds = this.state.selectedLineIds;
            let allCheckStatus = '';

            if (!e.target.checked) {
                selectedLineIds = difference(this.state.selectedLineIds, [id]);
            } else {
                selectedLineIds = union(this.state.selectedLineIds, [id]);
            }

            if (selectedLineIds.length === bookingLines.length) {
                allCheckStatus = 'All';
            } else if (selectedLineIds.length === 0) {
                allCheckStatus = 'None';
            } else {
                allCheckStatus = 'Some';
            }

            this.setState({selectedLineIds, allCheckStatus});
        } else if (type === 'TYPE-2') {
            const { orderStats } = this.state;
            let selectedOrderNos = this.state.selectedOrderNos;
            let allCheckStatus2 = '';

            if (!e.target.checked) {
                selectedOrderNos = difference(this.state.selectedOrderNos, [id]);
            } else {
                selectedOrderNos = union(this.state.selectedOrderNos, [id]);
            }

            if (selectedOrderNos.length === orderStats.length) {
                allCheckStatus2 = 'All';
            } else if (selectedOrderNos.length === 0) {
                allCheckStatus2 = 'None';
            } else {
                allCheckStatus2 = 'Some';
            }

            this.setState({allCheckStatus2, selectedOrderNos});
        }
    }

    onCheckAll(type) {
        if (type === 'TYPE-1') {
            const { bookingLines, filterKeyword, filterOnly } = this.state;
            let selectedLineIds = this.state.selectedLineIds;
            let allCheckStatus = this.state.allCheckStatus;

            if (
                (selectedLineIds.length > 0 && selectedLineIds.length < bookingLines.length) ||
                selectedLineIds.length === bookingLines.length
            ) { // If selected `All` or `Some`
                selectedLineIds = [];
                allCheckStatus = 'None';
            } else if (selectedLineIds.length === 0) { // If selected `None`
                selectedLineIds = bookingLines
                    .filter(line => {
                        if (!filterKeyword) return true;

                        const orderNumber = (line.b_client_order_num || '').toString();
                        const binNumber = (line.e_bin_number || '').toString();
                        const description = (line.e_item || '').toString();
                        const src = (orderNumber + binNumber + description).toLowerCase();
                        const keyword = filterKeyword.toLowerCase();
                        return src.indexOf(keyword) !== -1;
                    })
                    .filter(line => {
                        if (!filterOnly || filterOnly === 'all') return true;

                        return line.packed_status === filterOnly;
                    })
                    .map(line => line.pk_lines_id);
                allCheckStatus = 'All';
            }

            this.setState({allCheckStatus, selectedLineIds});
        } else if (type === 'TYPE-2') {
            const { orderStats } = this.state;
            let selectedOrderNos = this.state.selectedOrderNos;
            let allCheckStatus2 = this.state.allCheckStatus2;

            if (
                (selectedOrderNos.length > 0 && selectedOrderNos.length < orderStats.length) ||
                selectedOrderNos.length === orderStats.length
            ) { // If selected `All` or `Some`
                selectedOrderNos = [];
                allCheckStatus2 = 'None';
            } else if (selectedOrderNos.length === 0) { // If selected `None`
                selectedOrderNos = orderStats
                    .map(orderStat => orderStat.orderNumber);
                allCheckStatus2 = 'All';
            }

            this.setState({allCheckStatus2, selectedOrderNos});
        }
    }

    onInputChange(event, src=null) {
        /*
            event: input event
            data: selected lineDetail
            src: line or filter
        */

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (src === 'filter-keyword') {
            this.setState({filterKeyword: value});
        } else if (src === 'filter-only') {
            this.setState({filterOnly: value});
        } else {
            let formInputs = this.state.formInputs;
            formInputs[name] = value;
            formInputs['e_1_Total_dimCubicMeter'] = getCubicMeter(
                formInputs['e_qty'],
                formInputs['e_dimUOM'],
                formInputs['e_dimLength'],
                formInputs['e_dimWidth'],
                formInputs['e_dimHeight']
            );
            formInputs['e_Total_KG_weight'] = getWeight(formInputs['e_qty'], formInputs['e_weightUOM'], formInputs['e_weightPerEach']);
            formInputs['total_2_cubic_mass_factor_calc'] = (Number.parseFloat(formInputs['e_1_Total_dimCubicMeter']).toFixed(4) * 250).toFixed(2);
            formInputs['warranty_fee'] = Number.parseFloat(formInputs['warranty_value']) * Number.parseFloat(formInputs['warranty_percent']) / 100;
            this.setState({formInputs});
        }
    }

    onClickNewBtn(doNotify=true) {
        this.setState({
            currentLineId: null,
            editMode: 'create',
            formInputs: {
                b_client_order_num: this.state.selectedOrderNo,
                e_type_of_packaging: 'carton',
                packed_status: 'scanned',
                e_bin_number: 'REPACK-BIN',
                e_qty: 0,
                e_dimLength: 0,
                e_dimWidth: 0,
                e_dimHeight: 0,
                e_dimUOM: 'cm',
                e_weightUOM: 'kg',
                e_weightPerEach: 0,
                sscc: null,
                e_util_height: 0,
                e_util_cbm: 0,
                e_util_kg: 0,
                warranty_value: 0,
                warranty_percent: 2,
                warranty_fee: 0,
                note: '',
                is_deleted: false,
            },
            isShowLoadingSpinner: false,
        });

        if (doNotify) {
            this.props.notify('New form is ready');
        }
    }

    onClickOnlyNewBtn() {
        this.setState({filterKeyword: 'REPACK-BIN'});
    }

    onClickEditBtn(line, doNotify=true) {
        const currentLineId = line.pk_lines_id;
        const formInputs = JSON.parse(JSON.stringify(line));

        formInputs['b_client_order_num'] = line.b_client_order_num;
        formInputs['packed_status'] = line.packed_status;
        formInputs['e_type_of_packaging'] = (line.e_type_of_packaging || '').toLowerCase();
        formInputs['e_dimUOM'] = (line.e_dimUOM || '').toLowerCase();
        formInputs['e_weightUOM'] = (line.e_weightUOM || '').toLowerCase();
        formInputs['isUpdated'] = true;

        this.setState({
            editMode: 'update',
            formInputs,
            currentLineId
        });

        if (doNotify) {
            this.props.notify('Form is ready');
        }
    }

    onClickDuplicateBtn(line) {
        const { bookingLines } = this.state;
        let max_pk_lines_id = 0;

        bookingLines.map(bookingLine => {
            if (bookingLine.pk_lines_id > max_pk_lines_id) {
                max_pk_lines_id = bookingLine.pk_lines_id;
            }
        });

        bookingLines.push({
            ...line,
            pk_lines_id: max_pk_lines_id + 1,
            isNew: true,
        });

        this.setState({bookingLines, hasChange: true});

        this.props.notify('Line is duplicated');
    }

    onClickDeleteBtn(line) {
        const { bookingLines } = this.state;
        const lineIndex = bookingLines.findIndex(bookingLine => bookingLine.pk_lines_id === line.pk_lines_id);
        bookingLines[lineIndex]['is_deleted'] = line.is_deleted ? false : true;
        bookingLines[lineIndex]['isUpdated'] = true;
        this.setState({bookingLines, hasChange: true});

        if (bookingLines[lineIndex]['is_deleted']) {
            this.props.notify('Line is deleted');
        } else {
            this.props.notify('Line is restored');
        }
    }

    onClickDeleteSelected() {
        const { bookingLines, selectedLineIds } = this.state;
        const newBookingLines = bookingLines.filter(line => {
            if (selectedLineIds.indexOf(line.pk_lines_id) > -1) {
                line['is_deleted'] = true;
                line['isUpdated'] = true;
            }

            return line;
        });

        this.setState({
            bookingLines: newBookingLines,
            selectedLineIds: [],
            allCheckStatus: 'None',
            hasChange: true
        });
        this.props.notify(selectedLineIds.length + ' selected lines are deleted');
    }

    onSubmitForm(e) {
        e.preventDefault();
        const { bookingLines, currentLineId, formInputs, orderNumbers, selectedOrderNos } = this.state;

        // Order Number validation
        const lineIndex = orderNumbers.findIndex(
            orderNumber => orderNumber === formInputs['b_client_order_num']
        );
        if (lineIndex === -1 && selectedOrderNos.length < 2) {
            this.props.notify('Order Number should be retreived from selected orders');
            return;
        }

        if (currentLineId) {
            formInputs['isUpdated'] = true;
            const lineIndex = bookingLines.findIndex(bookingLine => bookingLine.pk_lines_id === currentLineId);
            bookingLines[lineIndex] = JSON.parse(JSON.stringify(formInputs));
            this.setState({bookingLines, hasChange: true});
            this.props.notify('Line is updated');
        }  else {
            let max_pk_lines_id = 0;
            bookingLines.map(bookingLine => {
                if (bookingLine.pk_lines_id > max_pk_lines_id) {
                    max_pk_lines_id = bookingLine.pk_lines_id;
                }
            });
            formInputs['isNew'] = true;

            if (selectedOrderNos.length > 1) {
                selectedOrderNos.map(orderNumber => {
                    formInputs['pk_lines_id'] = max_pk_lines_id + 1;
                    formInputs['b_client_order_num'] = orderNumber;
                    bookingLines.push(JSON.parse(JSON.stringify(formInputs)));
                });
                this.props.notify('Lines are created');
            } else {
                formInputs['pk_lines_id'] = max_pk_lines_id + 1;
                bookingLines.push(JSON.parse(JSON.stringify(formInputs)));
                this.props.notify('Line is created');
            }

            this.setState({bookingLines, hasChange: true, selectedOrderNos: []});
        }
    }

    onCancel(e, type) {
        e.preventDefault();
        const { bookingLines, currentLineId, hasChange } = this.state;

        if (type === 'form') {
            if (currentLineId) {
                const lineIndex = bookingLines.findIndex(bookingLine => bookingLine.pk_lines_id === currentLineId);
                this.onClickEditBtn(bookingLines[lineIndex], false);
            } else {
                this.onClickNewBtn(false);
            }
        } else if (type === 'modal') {
            if (hasChange) {
                this.toggleCloseConfirmModal();
            } else {
                this.setState({
                    orderStats: [],
                    orderNumbers: [],
                    bookingLines: [],
                    selectedLines: [],
                    selectedLineIds: [],
                    selectedLineIndex: null,
                    hasChange: false,
                    allCheckStatus: 'None',
                });

                this.props.toggle();
            }
        }
    }

    onConfirmClose(e) {
        e.preventDefault();

        this.setState({
            orderStats: [],
            orderNumbers: [],
            bookingLines: [],
            selectedLines: [],
            selectedLineIds: [],
            selectedLineIndex: null,
            hasChange: false,
            allCheckStatus: 'None',
        });
        this.toggleCloseConfirmModal();
        this.props.toggle();
    }

    onClickProceedBtn(e) {
        e.preventDefault();

        const { bookingLines } = this.state;
        this.props.editLinesBulk(bookingLines);
        this.setState({isShowLoadingSpinner: true, hasChange: false});
    }

    onClickGetLabelSelected(e) {
        e.preventDefault();

        const { selectedLineIds } = this.state;
        this.props.dmeLabelBulk(selectedLineIds);
        this.setState({isShowLoadingSpinner: true});
    }

    onSelectOrder(orderStat) {
        const { formInputs } = this.state;
        formInputs['b_client_order_num'] = orderStat['orderNumber'];

        this.setState({
            formInputs: formInputs,
            filterKeyword: orderStat['orderNumber'],
            selectedOrderNo: orderStat['orderNumber']
        });
    }

    onClickBoxSize(size) {
        const { formInputs } = this.state;
        if (size === 'small') {
            formInputs['e_dimLength'] = '33';
            formInputs['e_dimWidth'] = '22';
            formInputs['e_dimHeight'] = '25';
            formInputs['e_dimUOM'] = 'cm';
        } else if (size === 'medium') {
            formInputs['e_dimLength'] = '41';
            formInputs['e_dimWidth'] = '19';
            formInputs['e_dimHeight'] = '31';
            formInputs['e_dimUOM'] = 'cm';
        } else {
            formInputs['e_dimLength'] = '46';
            formInputs['e_dimWidth'] = '31';
            formInputs['e_dimHeight'] = '32';
            formInputs['e_dimUOM'] = 'cm';
        }

        this.setState({formInputs});
    }

    render() {
        const { isOpen, packageTypes, clientname } = this.props;
        const {
            filterKeyword, filterOnly, bookingLines, selectedLineIds, currentLineId, allCheckStatus, allCheckStatus2,
            formInputs, editMode, hasChange, orderStats, selectedOrderNo, selectedOrderNos
        } = this.state;

        const packageTypesOptions = packageTypes.map((packageType, key) => {
            return (<option key={key} value={packageType.dmePackageTypeDesc}>{packageType.dmePackageTypeDesc}</option>);
        });

        const orderStatList = orderStats.map((orderStat, index) => {
            let trClassName = 'pointer';

            if (selectedOrderNo === orderStat['orderNumber']) {
                trClassName += ' selected';
            }

            return (
                <tr key={index} className={trClassName}>
                    <td>
                        <input
                            type="checkbox"
                            checked={indexOf(selectedOrderNos, orderStat['orderNumber']) > -1 ? 'checked' : ''}
                            onChange={(e) => this.onCheck(e, orderStat['orderNumber'], 'TYPE-2')}
                        />
                    </td>
                    <td onClick={() => this.onSelectOrder(orderStat)}>{orderStat['orderNumber']}</td>
                    <td onClick={() => this.onSelectOrder(orderStat)}>{orderStat['b_bookingID_Visual']}</td>
                    <td onClick={() => this.onSelectOrder(orderStat)}>{orderStat['deToCompanyName']}</td>
                    <td>{orderStat['packet']}</td>
                    <td>{orderStat['carton']}</td>
                    <td>{orderStat['pallet']}</td>
                </tr>
            );
        });

        const lineList = bookingLines
            .filter(line => {
                if (!filterKeyword) return true;

                const orderNumber = (line.b_client_order_num || '').toString();
                const binNumber = (line.e_bin_number || '').toString();
                const description = (line.e_item || '').toString();
                const src = (orderNumber + binNumber + description).toLowerCase();
                const keyword = filterKeyword.toLowerCase();
                return src.indexOf(keyword) !== -1;
            })
            .filter(line => {
                if (!filterOnly || filterOnly === 'all') return true;

                return line.packed_status === filterOnly;
            })
            .sort((a, b) => {
                let aLevel = 0;
                if (CARTONS.includes(a.e_type_of_packaging.toUpperCase())) {
                    aLevel = 0;
                } else if (PALLETS.includes(a.e_type_of_packaging.toUpperCase())) {
                    aLevel = 1;
                } else {
                    aLevel = 2;
                }

                let bLevel = 0;
                if (CARTONS.includes(b.e_type_of_packaging.toUpperCase())) {
                    bLevel = 0;
                } else if (PALLETS.includes(b.e_type_of_packaging.toUpperCase())) {
                    bLevel = 1;
                } else {
                    bLevel = 2;
                }
                return bLevel - aLevel;
            })
            .map((line, index) => {
                const isCurrentClass = (line.pk_lines_id === currentLineId) ? 'current' : '';
                const isDeletedClass = line.is_deleted ? 'deleted' : '';
                const isNewlyCreated = line.e_bin_number !== 'REPACK-BIN' ? '' : 'new';

                return (
                    <tr key={index} className={isCurrentClass + ' ' + isDeletedClass + ' ' + isNewlyCreated}>
                        <td>
                            <input
                                type="checkbox"
                                checked={indexOf(selectedLineIds, line.pk_lines_id) > -1 ? 'checked' : ''}
                                onChange={(e) => this.onCheck(e, line.pk_lines_id, 'TYPE-1')}
                            />
                        </td>
                        <td>{line.b_client_order_num}</td>
                        <td>{line.e_bin_number}</td>
                        <td>{PACKED_STATUS_MAP[line.packed_status]}</td>
                        <td>{line.e_type_of_packaging}</td>
                        <td>{line.e_item}</td>
                        <td>{line.e_qty}</td>
                        <td>{line.e_weightUOM}</td>
                        <td>{line.e_weightPerEach}</td>
                        <td>{(line.e_Total_KG_weight || 0).toFixed(2)}</td>
                        <td>{line.e_dimUOM}</td>
                        <td>{line.e_dimLength}</td>
                        <td>{line.e_dimWidth}</td>
                        <td>{line.e_dimHeight}</td>
                        <td className="actions">
                            <Button color="info" onClick={() => this.onClickEditBtn(line)}>
                                <i className="icon icon-pencil"></i>
                            </Button>
                            <Button color="success" onClick={() => this.onClickDuplicateBtn(line)}>
                                <i className='fa fa-copy' aria-hidden="true"></i>
                            </Button>
                            <Button color="danger" onClick={() => this.onClickDeleteBtn(line)}>
                                {line.is_deleted
                                    ? <i className='fa fa-recycle' aria-hidden="true"></i>
                                    : <i className='fa fa-trash' aria-hidden="true"></i>
                                }
                            </Button>
                        </td>
                    </tr>
                );
            });

        return (
            <ReactstrapModal isOpen={isOpen} className="items-modal">
                <LoadingOverlay
                    active={this.state.isShowLoadingSpinner}
                    spinner
                    text='Loading...'
                >
                    <ModalHeader toggle={(e) => this.onCancel(e, 'modal')}><strong>Items Modal</strong></ModalHeader>
                    <ModalBody>
                        <div className='control'>
                            <div className='filter'>
                                <label>
                                    Filter:&nbsp;&nbsp;
                                    <input
                                        name="filterKeyword"
                                        onChange={(e) => this.onInputChange(e, 'filter-keyword')}
                                        value={filterKeyword}
                                    />
                                    <a onClick={() => this.setState({filterKeyword: ''})} className='pointer'>
                                        <i
                                            className={filterKeyword ? 'fa fa-times-circle c-red' : 'fa fa-times-circle c-gray'}
                                            aria-hidden="true">
                                        </i>
                                    </a>
                                </label>
                                <label>
                                    Only:&nbsp;&nbsp;
                                    <select 
                                        id="filter-only"
                                        onChange={(e) => this.onInputChange(e, 'filter-only')}
                                        value={filterOnly}
                                    >
                                        <option value={'all'}>All</option>
                                        <option value={'original'}>Send As Is</option>
                                        <option value={'auto'}>Auto Repack</option>
                                        <option value={'manual'}>Manual Repack</option>
                                        <option value={'scanned'}>Actual/Scanned</option>
                                    </select>
                                    <a onClick={() => this.setState({filterOnly: 'all'})} className='pointer'>
                                        <i
                                            className={filterOnly !== 'all' ? 'fa fa-times-circle c-red' : 'fa fa-times-circle c-gray'}
                                            aria-hidden="true">
                                        </i>
                                    </a>
                                </label>
                                <Button className="Only New" onClick={() => this.onClickOnlyNewBtn()} color="success">Only New</Button>
                                <label className='selected-cnt float-r'>
                                    <span>Selected: <strong>{selectedLineIds.length}</strong></span>
                                </label>
                            </div>
                            <div className='actions'>
                                <Button className="new" onClick={() => this.onClickNewBtn()} color="primary">+</Button>
                                <Button className="delete-selected" onClick={() => this.onClickDeleteSelected()} color="danger">Delete (selected)</Button>
                            </div>
                        </div>
                        <hr />
                        <div className='show'>
                            <div className='table'>
                                <table className="table table-hover table-bordered table-striped sortable fixed_headers">
                                    <thead>
                                        <tr>
                                            <th className="" scope="col" nowrap="true">
                                                <input
                                                    type="checkbox"
                                                    className={(allCheckStatus === 'All' || allCheckStatus === 'None') ? 'checkall' : 'checkall some'}
                                                    checked={allCheckStatus !== 'None' ? 'checked' : ''}
                                                    onChange={() => this.onCheckAll('TYPE-1')}
                                                />
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Order No</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Bin Number</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Group</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Packaging</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Item Description</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Qty</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Wgt UOM</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Wgt Each</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Total Kgs</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Dim UOM</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Length</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Width</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Height</p>
                                            </th>
                                            <th className="" scope="col" nowrap="true">
                                                <p>Actions</p>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { lineList }
                                    </tbody>
                                </table>
                            </div>
                            <div className='form'>
                                <div className='stats'>
                                    <table className="table table-hover table-bordered table-striped sortable fixed_headers">
                                        <thead>
                                            <tr>
                                                <th className="" scope="col" nowrap="true">
                                                    <input
                                                        type="checkbox"
                                                        className={(allCheckStatus2 === 'All' || allCheckStatus2 === 'None') ? 'checkall' : 'checkall some'}
                                                        checked={allCheckStatus2 !== 'None' ? 'checked' : ''}
                                                        onChange={() => this.onCheckAll('TYPE-2')}
                                                    />
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>Order No</p>
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>Booking Id</p>
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>DE Entity</p>
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>Packet</p>
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>Carton</p>
                                                </th>
                                                <th className="" scope="col" nowrap="true">
                                                    <p>Pallet</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { orderStatList }
                                        </tbody>
                                    </table>
                                </div>
                                <form onSubmit={(e) => this.onSubmitForm(e)} role="form">
                                    {selectedOrderNos.length < 2 &&
                                        <label>
                                            <p>Order Number <strong className='c-red'>*</strong></p>
                                            <input
                                                className="form-control"
                                                type="text"
                                                name="b_client_order_num"
                                                value={formInputs.b_client_order_num || ''}
                                                onChange={(e) => this.onInputChange(e)}
                                                required
                                            />
                                        </label>
                                    }
                                    <label>
                                        <p>Packed Status <strong className='c-red'>*</strong></p>
                                        <select
                                            required
                                            name="packed_status"
                                            onChange={(e) => this.onInputChange(e)}
                                            value = {formInputs.packed_status}
                                        >
                                            <option value={'original'}>Send As Is</option>
                                            <option value={'auto'}>Auto Repack</option>
                                            <option value={'manual'}>Manual Repack</option>
                                            <option value={'scanned'}>Actual/Scanned</option>
                                        </select>
                                    </label>
                                    <label>
                                        <p>Packaging <strong className='c-red'>*</strong></p>
                                        <select
                                            name="e_type_of_packaging"
                                            onChange={(e) => this.onInputChange(e)}
                                            value = {formInputs.e_type_of_packaging || ''}
                                        >
                                            {packageTypesOptions}
                                        </select>
                                    </label>
                                    <label>
                                        <p>Item Description <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="e_item"
                                            value={formInputs.e_item || ''}
                                            onChange={(e) => this.onInputChange(e)}
                                        />
                                    </label>
                                    <label>
                                        <p>Bin Number</p>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="e_bin_number"
                                            value={formInputs.e_bin_number || ''}
                                            onChange={(e) => this.onInputChange(e)}
                                            disabled={clientname === 'Aberdeen Paper' ? 'disabled' : ''}
                                        />
                                    </label>
                                    <label>
                                        <p>Qty <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="1"
                                            min="1"
                                            name="e_qty"
                                            value={formInputs.e_qty || ''}
                                            onChange={(e) => this.onInputChange(e)}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Wgt UOM <strong className='c-red'>*</strong></p>
                                        <select
                                            name="e_weightUOM"
                                            onChange={(e) => this.onInputChange(e)}
                                            value = {formInputs.e_weightUOM}
                                        >
                                            <option value="kg">Kilogram</option>
                                            <option value="g">Gram</option>
                                            <option value="t">Ton</option>
                                        </select>
                                    </label>
                                    <label>
                                        <p>Wgt Each <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            name="e_weightPerEach"
                                            value={formInputs.e_weightPerEach || 0}
                                            onChange={(e) => this.onInputChange(e)}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Total Kgs</p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            disabled="disabled"
                                            name="e_Total_KG_weight"
                                            value={formInputs.e_Total_KG_weight || 0}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Dim UOM <strong className='c-red'>*</strong></p>
                                        <select
                                            name="e_dimUOM"
                                            onChange={(e) => this.onInputChange(e)}
                                            value = {formInputs.e_dimUOM} >
                                            <option value="m">METER</option>
                                            <option value="cm">CM</option>
                                            <option value="mm">MM</option>
                                        </select>
                                    </label>
                                    <label>
                                        <p>Choose a size:</p><br />
                                        <label className="display-inline">
                                            <input type='radio' name='size' value='small' onClick={() => this.onClickBoxSize('small')} />
                                            Small
                                        </label>
                                        <label className="display-inline">
                                            <input type='radio' name='size' value='medium' onClick={() => this.onClickBoxSize('medium')} />
                                            Medium
                                        </label>
                                        <label className="display-inline">
                                            <input type='radio' name='size' value='large' onClick={() => this.onClickBoxSize('large')} />
                                            Large
                                        </label>
                                    </label>
                                    <label>
                                        <p>Length <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            name="e_dimLength"
                                            value={formInputs.e_dimLength || 0}
                                            onChange={(e) => this.onInputChange(e)}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Width <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            name="e_dimWidth"
                                            value={formInputs.e_dimWidth || 0}
                                            onChange={(e) => this.onInputChange(e)}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Height <strong className='c-red'>*</strong></p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            name="e_dimHeight"
                                            value={formInputs.e_dimHeight ||  0}
                                            onChange={(e) => this.onInputChange(e)}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Cubic Meter</p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            step="0.001"
                                            min="0.001"
                                            disabled="disabled"
                                            name="e_1_Total_dimCubicMeter"
                                            value={formInputs.e_1_Total_dimCubicMeter || 0}
                                            required
                                        />
                                    </label>
                                    <label>
                                        <p>Cubic KG</p>
                                        <input
                                            className="form-control"
                                            type="number"
                                            disabled="disabled"
                                            name="total_2_cubic_mass_factor_calc"
                                            value={formInputs.total_2_cubic_mass_factor_calc || 0}
                                        />
                                    </label>
                                    <label>
                                        <p>SSCC</p>
                                        <input
                                            className="form-control"
                                            type="text"
                                            name="sscc"
                                            value={formInputs.sscc || ''}
                                            onChange={(e) => this.onInputChange(e)}
                                        />
                                    </label>
                                    <label>
                                        <Button type="submit" color="primary">
                                            {editMode === 'create'
                                                ? `Create${selectedOrderNos.length < 2 ? '' : ' Bulk'}`
                                                : 'Update'
                                            }
                                        </Button>{' '}
                                        <Button color="danger" onClick={(e) => this.onCancel(e, 'form')}>Cancel</Button>
                                    </label>
                                </form>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={(e) => this.onClickProceedBtn(e)}
                            color="primary"
                            disabled={!hasChange}
                        >
                            Proceed
                        </Button>
                        <Button
                            onClick={(e) => this.onClickGetLabelSelected(e)}
                            color="success"
                            disabled={hasChange || selectedLineIds.length === 0}
                        >
                            Get Label (selected)
                        </Button>
                        <Button color="danger" onClick={(e) => this.onCancel(e, 'modal')}>Cancel</Button>
                    </ModalFooter>
                </LoadingOverlay>

                <ConfirmModal
                    isOpen={this.state.isShowCloseConfirmModal}
                    onOk={(e) => this.onConfirmClose(e)}
                    onCancel={this.toggleCloseConfirmModal}
                    title={'Confirmation'}
                    text={'You could lost updated data. Are you sure you want to close this modal?'}
                    okBtnName={'Sure'}
                />
            </ReactstrapModal>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        clientname: state.auth.clientname,
        packageTypes: state.extra.packageTypes,
        bookingLines: state.bookingLine.bookingLines,
        labelUrl: state.booking.labelUrl,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getLinesBulk: (bookingIds) => dispatch(getLinesBulk(bookingIds)),
        editLinesBulk: (bookingLines) => dispatch(editLinesBulk(bookingLines)),
        getPackageTypes: () => dispatch(getPackageTypes()),
        dmeLabelBulk: (bookingId, lineIds) => dispatch(dmeLabelBulk(bookingId, lineIds)),
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ItemsModal));



// WEBPACK FOOTER //
// ./src/components/CommonModals/ItemsModal.js